<script>
    export let content = {message: ''}
    const MAX_CONTENT_LENGTH = 400
    $: content.message = content.message.replace(/(\r\n|\n|\r)/gm, '')
    export let demoMessage
    const typewriter = (node, {speed = 30}) => {
        if (!demoMessage) return
        const duration = demoMessage.length * speed
        return {
            delay: 500,
            duration,
            tick: t => {
                const i = Math.ceil(demoMessage.length * t)
                content.message = demoMessage.slice(0, i)
            }
        }
    }

    function onKeyDown(event) {
        if (event.keyCode === 13) {
            event.target.blur()
        }
    }
</script>

<style>
    .postCard {
        background: white;
        border: var(--area) 1px solid;
        border-radius: 0.5rem;
        margin-left: auto;
        margin-right: auto;
        width: 320px;
        height: 213px;
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
        position: relative;
        padding: 1em;
        font-size: 0.6rem;
        /*min-height: 70%;*/
    }

    img {
        color: #EE5A24;
        position: absolute;
        width: 32px;
        height: 32px;
        right: 1em;
        top: 1em;
        opacity: 0.1;
        z-index: 4;
        user-select: none;
    }

    input {
        background: none;
        padding: 0.666em;
        font-size: 1.5em;
        font-weight: bold;
        border: none;
        color: #4C51BF;
    }

    textarea {
        border-radius: 0;
        /*font-size: 0.7em;*/
        padding: 1em;
        resize: none;
        background: none;
        transition: none;
        margin-bottom: 0.5rem;
        margin-top: -0.5rem;
        font-weight: 600;
    }

    input:focus, textarea:focus {
        box-shadow: none;
        outline: var(--gray) 1px solid;
        border-radius: 2px;
    }

    textarea::placeholder {
        color: var(--gray);
    }

    textarea:focus::placeholder {
        color: transparent;
    }

    .hint {
        display: none;
        line-height: 0;
    }

    textarea:focus + .hint {
        display: block;
    }

    .timeText {
        color: var(--near-ink);
        font-size: 0.6em;
    }

    @media (min-width: 36em) {
        .postCard {
            width: 480px;
            height: 320px;
            font-size: 1rem;
        }

        img {
            width: 48px;
            height: 48px;
        }
    }
</style>
<div class="postCard flex flex-column justify-end">
    <img src="res/stamp.svg" alt="" draggable=false>
    <input bind:value={content.title} placeholder="Title" maxlength=36/>
    <textarea class='flex-auto'
              name="text" id="" rows="1" maxlength={MAX_CONTENT_LENGTH}
              in:typewriter
              on:keydown={onKeyDown}
              bind:value={content.message}
              placeholder="Type your message here!"></textarea>

    <h6 class='hint self-end' class:redText={content.message.length >= MAX_CONTENT_LENGTH}>{content.message.length}
        / {MAX_CONTENT_LENGTH}</h6>
    <h6 class='timeText self-center'>Sent on {new Date().toLocaleDateString()}</h6>
</div>